import { ButtonBase, Grid, IconButton, useMediaQuery } from "@mui/material";
import React from "react";
import main_banner_image from "../../assets/banner_taxi.jpg";
import banner2 from "../../assets/bg2.webp";
import { BsArrowRightCircle } from "react-icons/bs";
import { MdOutlineArrowOutward } from "react-icons/md";

//css imports
import "../../components/mainstyling/mainstyling.css";
import "./css/responsive_mainpage.css";

// image imports
import estimate from "../../assets/estimate.png";

// utils import
import { we_do_details } from "./utils/WeDoUtils";
import MainpageHook from "./hooks/MainpageHook";

const Main = () => {
  const { ...param } = MainpageHook();
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={12} md={12}>
          {/* // main page banner grid container */}

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            rowSpacing={1}
          >
            <Grid item xs={12} md={12}>
              <div className="def-banner-image-container">
                <div className="perma-banner-wrapper">
                  <div className="banner-holder">
                    <img
                      src={main_banner_image}
                      alt=""
                      className="main-banner"
                    />
                  </div>
                  <div className="main-hero-text-container">
                    <h3>Now its easy for you to rent a car.</h3>
                    <p>We offer the best prices.</p>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>

        {/* section 2 ,  what we offer*/}

        <Grid item xs={12} md={12}>
          <Grid
            container
            spacing={{ xs: 1, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            rowSpacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <div className="def-banner-image-container">
                <div className="sec2-perma-banner-wrapper">
                  <div className="sec2-banner-holder">
                    <img src={banner2} alt="" className="banner-image-perma" />
                  </div>

                  <div className="we-offer-container">
                    <Grid
                      container
                      columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                      spacing={{ xs: 2, md: 3 }}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item xs={11} md={10}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                          columnSpacing={{ xs: 1, sm: 3, md: 15 }}
                          direction={isMobile ? "column-reverse" : ""}
                        >
                          <Grid item xs={12} md={6}>
                            <Grid
                              container
                              spacing={{ xs: 1, md: 1 }}
                              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                              rowSpacing={1}
                            >
                              {we_do_details.map((item) => (
                                <Grid item xs={12} sm={6} md={6}>
                                  <div className="we-do">
                                    <div className="img-wapper">
                                      <div className="left-img-container">
                                        <img
                                          src={item.icon}
                                          alt=""
                                          className="main-icon"
                                        />
                                      </div>
                                    </div>

                                    <div className="title">
                                      <h3>{item.title}</h3>
                                      <p>{item.description}</p>
                                    </div>

                                    <div className="more-icon-container">
                                      <div className="btn-wrapper">
                                        <IconButton>
                                          <BsArrowRightCircle className="icon" />
                                        </IconButton>
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <div className="right-content">
                              <Grid container spacing={0}>
                                <Grid item xs={12} md={12}>
                                  <p>OUR SERVICES</p>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <h2>
                                   Seamless solutions for transportation, tracking, and delivery.
                                  </h2>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <p className="p-long">
                                  Unlocking Mobility: Delivering Reliable Solutions for Transportation, Navigation, and Convenience.
                                  </p>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  
                                </Grid>
                              </Grid>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>

        {/* company profile section */}
        {/* 
        <Grid item xs={12} md={12} className="sec3-main-container">
          <Grid
            container
            columns={{ xs: 12, sm: 12, md: 12 }}
            columnSpacing={{ xs: 1, sm: 3, md: 3 }}
            spacing={{ xs: 2, md: 3 }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <div className="dashed-text">
                <p>Our Company</p>
              </div>
              <h3>Company Profile</h3>
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </>
  );
};

export default Main;
